export default class UserCompanyConsentTerm {
  
    constructor() {
        this.userId = "";
        this.companyId = "";
        this.campaignId = null;
        this.ipAddress = "";
        this.accepted = false;
    }

}